export const perfilChangeLinkedin = {
  "LinkedIn": "LinkedIn",
  "Fechar": "Cerrar",
  "Aviso": "Aviso",
  "Dados atualizado com sucesso.": "Datos actualizados con éxito.",
  "Por favor, informe um perfil válido. Caso no sepa cómo, acceda a LinkedIn, haga clic en visualizar perfil y copie la URL del navegador.": "Por favor, proporcione un perfil válido. Si no sabe cómo, acceda a LinkedIn, haga clic en visualizar perfil y copie la URL del navegador.",
  "Whatsapp": "Whatsapp",
  "Salvar": "Guardar",
  "Campo obrigatório.": "Campo obligatorio."
};


// WEBPACK FOOTER //
// ./src/resources/es/perfilChangeLinkedin.js